import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { ApprovalContentService } from '../../services/approval-content.service';
import { TravelerManagement } from 'src/app/services/dataLayer/CAM/traveler-management.service';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatFormField, MatLabel, MatSuffix } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/autocomplete';
import { MatInput } from '@angular/material/input';
import { MatButton } from '@angular/material/button';
import { BookingContentService } from "src/app/services/bookingContentService/booking-content.service";
import { ContentService } from "src/app/modules/cam/services/content.service";

@Component({
    selector: 'app-approvers',
    templateUrl: './approvers.component.html',
    styleUrls: ['./approvers.component.scss'],
    imports: [ReactiveFormsModule, FormsModule, MatFormField, MatLabel, MatIcon, MatSuffix, MatSelect, MatOption, MatInput, MatButton]
})
export class ApproversComponent implements OnInit, OnDestroy {
    manageTravelerDataContent: any;
    approvalManageContent: any;
  private destroy$ = new Subject<void>();
  content: any;
  constructor(private readonly manageTravelerContentService: ContentService, private readonly bookingContentService: BookingContentService, private contentService: ApprovalContentService, private travelerDataLayer: TravelerManagement) {

  }
  ngOnInit() {
    this.contentService.content$.pipe(takeUntil(this.destroy$)).subscribe((res: any) => {
      this.content = res;
    })
      this.contentService.content$.subscribe((res: any) => { this.approvalManageContent = res; });
      this.manageTravelerContentService.content$.subscribe((res: any) => { this.manageTravelerDataContent = res; });
  }

  cancelApprovers() {
    this.travelerDataLayer.reporting_manager_manager_settings_click( 0, 'Cancel' );
  }

  saveApprovers() {
    this.travelerDataLayer.reporting_manager_manager_settings_click( 0, 'Save' );
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
